export default async function({ store }) {
  if (!store.state.users.detail?.id) {
    await store.dispatch('users/getSelf')
  }
}
